/// <amd-module name="Wiki/Editor/EditTelemetryHelper" />
import { IVssPageContext } from "VSS/Platform/Context";

import { WikiType } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { IWikiEditorState } from "Wiki/Editor/Contracts";
import { WikiPageInfoWithName } from "Wiki/ViewCommon/Contracts";
import { SaveOptionType, SavePageOperationType, TelemetryConstants } from "Wiki/ViewCommon/CustomerIntelligenceConstants";
import { getDepthOfPage, isInclude } from "Wiki/ViewCommon/Utils/PathHelper";
import { publish } from "Wiki/ViewCommon/Utils/WikiHelper";

export function publishPageSaveAttempted(
    pageContext: IVssPageContext,
    editorState: IWikiEditorState,
    pageInfo: WikiPageInfoWithName,
    saveOptionType: SaveOptionType,
    wikiType: WikiType
): void {
    let savePageOperationType = SavePageOperationType.EditPage;
    if (!pageInfo.pageName) {
        savePageOperationType = SavePageOperationType.CreatePage;
    } else if (pageInfo.pageName !== editorState.pageName) {
        savePageOperationType = SavePageOperationType.RenamePage;
        if (pageInfo.content !== editorState.pageContent) {
            savePageOperationType = SavePageOperationType.RenameEditPage;
        }
    }

    const props: { [key: string]: any } = {
        saveOptionType: saveOptionType,
        savePageOperationType: savePageOperationType,
        depth: getDepthOfPage(pageInfo.parentPath) + 1
    };

    props[TelemetryConstants.IsIncludePageKey] = isInclude(pageInfo.parentPath);
    publish(pageContext, TelemetryConstants.PageSaveAttempted, wikiType, props);
}
